/**
 * Vuex actions for the zoom module.
 *
 * @module store/modules/zoom/actions
 */
import { rest } from "@/store/api";
import { RootState } from "@/store/types";
import { ActionTree } from "vuex/types";
import { ZoomState } from "./types";

const actions: ActionTree<ZoomState, RootState> = {
  /**
   * Creates and starts a new Zoom meeting for a chat session.
   *
   * @param {ActionContext} context - Vuex action context
   * @param {Object} payload - Action payload
   * @param {Object} payload.chat - Chat object containing PartitionKey, user_id, and sessionId
   * @param {string} payload.meeting_id - Optional meeting ID for specific meeting
   * @returns {Promise<Object>} Meeting details with id, start_url, and join_url
   *
   * @example
   * const meeting = await this.$store.dispatch('ZOOM_MEETING_START', {
   *   chat: chatObject,
   *   meeting_id: 'optional-id'
   * });
   */
  ZOOM_MEETING_START: async ({ state, commit, dispatch }, { chat, meeting_id }) => {
    const page_id = chat.PartitionKey;
    const user_id = chat.user_id;
    const session_id = chat.sessionId;

    const { id, start_url, join_url } = await rest("post", "zoom_meeting_create", { page_id, user_id, session_id, meeting_id });

    const payload = {
      user_id,
      meeting_id: id,
      start_url,
      join_url,
    }
    commit("SET_ZOOM_MEETING", payload);

    return { id, start_url, join_url };
  }
};

export default actions;
